import React from 'react';
import Svg from '../Svg';

const IconUnderline02 = ({ ...props }) => (
  <Svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4C2 3.44772 2.44772 3 3 3L4.9994 3C4.9996 3 4.9998 3 5 3C5.0002 3 5.0004 3 5.0006 3L8.49901 3C8.49934 3 8.49967 3 8.5 3C8.50033 3 8.50066 3 8.50099 3L10.5 3C11.0523 3 11.5 3.44772 11.5 4C11.5 4.55229 11.0523 5 10.5 5L9.5 5V10C9.5 12.7036 11.289 14.9919 13.7495 15.7409C16.2098 14.9921 18 12.7051 18 10V5H17C16.4477 5 16 4.55228 16 4C16 3.44772 16.4477 3 17 3L18.9994 3C18.9996 3 18.9998 3 19 3C19.0002 3 19.0004 3 19.0006 3L21 3C21.5523 3 22 3.44772 22 4C22 4.55229 21.5523 5 21 5L20 5V10C20 14.4183 16.4183 18 12 18C7.58172 18 4 14.4183 4 10V5H3C2.44772 5 2 4.55228 2 4ZM6 5V10C6 12.5192 7.55253 14.6757 9.75299 15.5651C8.35847 14.1255 7.5 12.1634 7.5 10V5L6 5ZM3 21C3 20.4477 3.44772 20 4 20H20C20.5523 20 21 20.4477 21 21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21Z"
    />
  </Svg>
);

export default IconUnderline02;
